import { ApolloProvider } from "@apollo/client";
import StayOnCurrentShift from "components/Dashboard/range-selectors/StayOnCurrentShift";

import { askrClients } from "../../providers/AskrProvider";
import { useCustomerKey } from "../../utils/customHooks/useCustomerKey";
import DashboardPagesContent from "./DashboardPagesContent/DashboardPagesContent";
import InitializeDashboardPagesHooks from "./DashboardPagesContent/InitializeDashboardPagesHooks";
import { useDispatch } from "react-redux";
import { updateCustomerKey } from "store/customerSlice";
import { getCkeyFromWindow } from "constants/constants";
import { useEffect, useTransition } from "react";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";

function DashboardPages(): React.JSX.Element | null {
  const ckey = useCustomerKey();
  const dispatch = useDispatch();
  const [, startTransition] = useTransition();

  useEffect(() => {
    if (!ckey) {
      startTransition(() => {
        dispatch(updateCustomerKey(getCkeyFromWindow()));
      });
    }
  }, [ckey, dispatch]);

  if (!ckey) {
    return null;
  }
  return (
    <ApolloProvider client={askrClients.get(ckey)}>
      <ErrorBoundary small={true} overlay={true} id="DashboardPagesHooks">
        <DashboardPagesHooks />
      </ErrorBoundary>
      <ErrorBoundary id="DashboardPagesContent">
        <DashboardPagesContent />
      </ErrorBoundary>
    </ApolloProvider>
  );
}

export default DashboardPages;

function DashboardPagesHooks() {
  return (
    <>
      <StayOnCurrentShift />
      <InitializeDashboardPagesHooks />
    </>
  );
}
